module.exports = __webpack_public_path__ + "assets/media/prize.3de37a03.jpg";